import React, { useRef, useState } from 'react'
import { Modal, Button } from 'antd'
import axios from '../../../utils/AxiosUtil'
import { mask, unmask } from '../../../components/reqAndHint'
import { useSelector } from 'react-redux'
import { relate_cols } from '../../../constants/donateListConstants'

//红冲抵消（当月红冲发票金额为负，关联的票据金额为正，且总和等于红冲发票金额） 暂用不到
export default function relateReverseModal(props) {

    let { rmVisible, setRmVisible, detailList, setBillDetailList, actionRef } = props;
    const [reverseBillDetail, setReverseBillDetail] = useState();

    const langValue = useSelector(state => state.langList.value)
    let cur = useRef({}).current;
    cur.totalAmt = 0;
    let monthSet = new Set();
    detailList ?.forEach(d => {
        cur.totalAmt += +d['票据金额'];
        let date = d['开立日'];
        let mIndex = date.lastIndexOf('-');
        let ym = date.substring(0, mIndex);
        monthSet.add(ym);
    })

    let monthValid = monthSet.size == 1 ? true : false;
    cur.totalAmt = Math.round(cur.totalAmt * 100) / 100;
    let yyyyMM = null;
    if (monthValid) {
        yyyyMM = Array.from(monthSet)[0].replace('-', '');
    }

    const batchRelate = async (detailList) => {
        console.log('batchRelate:', detailList);
        if (!reverseBillDetail) {
            Modal.warn({
                content: langValue == 0 ?
                    <>无原冲正发票信息，请输入正确的发票号点“查询”<br />No original corrected invoice information, please enter the correct invoice number and click 'Search'</> :
                    (langValue == 1 ? '无原冲正发票信息，请输入正确的发票号点“查询”' :
                        'No original corrected invoice information, please enter the correct invoice number and click "Search"')
            });
            return;
        }
        if (Math.abs(+reverseBillDetail.amount) != cur.totalAmt) {
            Modal.warn({
                content: langValue == 0 ?
                    <>红冲发票金额和关联票据总额不相等！<br />The red invoice amount and the total amount of associated bills are not equal!</> :
                    (langValue == 1 ? '红冲发票金额和关联票据总额不相等！' :
                        'The red invoice amount and the total amount of associated bills are not equal!')
            });
            return;
        }
        if (detailList.length > 1000) {
            Modal.warn({ content: langValue == 0 ? <>关联票据不能超过1000张<br />The number of associated bills cannot exceed 1000</> : (langValue == 1 ? '关联票据不能超过1000张' : 'The number of associated bills cannot exceed 1000') });
            return;
        }
        let bill_code_list = [];
        let reverse_bill_code = cur.reverse_bill_code;
        for (let i = 0; i < detailList.length; i++) {
            let d = detailList[i];
            bill_code_list.push(d['票据号码']);
        };
        mask();
        let { data } = await axios.post('/fund/billmgt/relateReverseBillDetail', { bill_code_list, yyyyMM, reverse_bill_code }, { timeout: 120000 });
        unmask();
        if (data) {
            if (data.ret == 0) {
                Modal.info({
                    content: langValue == 0 ? <>关联成功,可在“状态”选“红冲发票”“关联红冲”分别查看原发票和已关联票据<br />The association is successful. You can select "Red Invoice" and "Associated Red Invoice" in the "Status" to view the original invoice and associated bills separately</> : (langValue == 1 ? '关联成功,可在“状态”选“红冲发票”“关联红冲”分别查看原发票和已关联票据' : 'The association is successful. You can select "Red Invoice" and "Associated Red Invoice" in the "Status" to view the original invoice and associated bills separately'),
                    okText: langValue == 0 ? '确定Yes' : (langValue == 1 ? '确定' : 'Yes'),
                    onOk: () => {
                        setBillDetailList();
                        setRmVisible(false);
                        actionRef.current.reload();
                        actionRef.current.clearSelected();
                    }
                })
            } else {
                let msg = '关联失败';
                let en_msg = 'Association failed'
                if (data.msg) {
                    msg = data.msg;
                }
                if (data.en_msg) {
                    en_msg = data.en_msg
                }
                Modal.warn({ content: langValue == 0 ? (msg + en_msg) : (langValue == 1 ? msg : en_msg) });
            }
        }
    }

    return (
        <>
            <Modal
                title={langValue == 0 ? '关联红冲发票Associated red invoices' : (langValue == 1 ? '关联红冲发票' : 'Associated red invoices')}
                centered
                visible={rmVisible}
                onCancel={() => {
                    setBillDetailList();
                    setRmVisible(false);
                }}
                footer={null}
                width={'100%'}
            >
                {detailList && detailList.length ?
                    <>
                        {
                            monthValid
                                ?
                                <div style={{ fontSize: '1.3rem', marginBottom: '0.5rem' }}>{langValue == 0 ? '要关联的红冲发票号The red invoice number to be associated' : (langValue == 1 ? '要关联的红冲发票号' : 'The red invoice number to be associated')}：<input id='r_bill_code' placeholder={langValue == 0 ? '请输入Please enter' : (langValue == 1 ? '请输入' : 'Please enter')} />
                                    <Button type='primary'
                                        style={{ fontSize: '1.3rem', height: '2.6rem' }}
                                        onClick={async () => {
                                            if (!yyyyMM) {
                                                alert('无效的月份，请重选');
                                                return;
                                            }
                                            let bill_code = document.getElementById('r_bill_code').value;
                                            mask();
                                            let { data } = await axios.post('/fund/billmgt/queryBillDetail', { yyyyMM, bill_code, status: 2 });
                                            unmask();
                                            if (data && data.length) {
                                                cur.reverse_bill_code = bill_code;
                                                setReverseBillDetail(data[0]);
                                            } else {
                                                setReverseBillDetail(null);
                                            }
                                        }}>{langValue == 0 ? '查询Query' : (langValue == 1 ? '查询' : 'Query')}</Button></div>

                                :
                                <div style={{ fontSize: '1.3rem', marginBottom: '0.5rem', color: 'red' }}>{langValue == 0 ? <>勾选的票据不在同一个月，请重新选择<br />The selected tickets are not in the same month, please select again</> : (langValue == 1 ? '勾选的票据不在同一个月，请重新选择' : 'The selected tickets are not in the same month, please select again')}</div>}
                        <table className='red_bill_table'>
                            <tbody>
                                <tr><th colSpan={15} className='bill_title'>{langValue == 0 ? '原红冲发票Original red invoice' : (langValue == 1 ? '原红冲发票' : 'Original red invoice')}</th></tr>
                                {
                                    reverseBillDetail ?
                                        (<>
                                            <tr>
                                                {relate_cols.map(item => {
                                                    return (
                                                        <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                                    )
                                                })}
                                            </tr>
                                            <tr>
                                                <td >{reverseBillDetail ?.['bill_code']}</td>
                                                <td >{reverseBillDetail ?.['bill_date'] ?.substring(0, 10)}</td>
                                                <td>{reverseBillDetail ?.['bill_detail_name']}</td>
                                                <td style={{ color: 'red' }}>{reverseBillDetail ?.['amount']}</td>
                                                <td>{langValue == 0 ? (<>{reverseBillDetail ?.['purpose']}<br />{reverseBillDetail ?.['purpose']}</>) : (langValue == 1 ? (reverseBillDetail ?.['purpose']) : (reverseBillDetail ?.['purpose']))}</td>
                                                <td>{reverseBillDetail ?.['area']}</td>
                                                <td>{reverseBillDetail ?.['volunteer_code']}</td>
                                                <td>{reverseBillDetail ?.['volunteer_name']}</td>
                                                <td>{reverseBillDetail ?.['phone']}</td>
                                                <td>{reverseBillDetail ?.['email']}</td>
                                                <td>{reverseBillDetail ?.['reason']}</td>
                                            </tr>
                                        </>)
                                        :
                                        <tr>
                                            <th colSpan={15} style={{ color: 'red' }}>{langValue == 0 ? <>无数据，请输入正确的发票号查询，需和关联票据同一月份（且发票金额是负数）<br />No data available, please enter the correct invoice number to query. It should be in the same month as the associated invoice (and the invoice amount should be negative)</> : (langValue == 1 ? '无数据，请输入正确的发票号查询，需和关联票据同一月份（且发票金额是负数）' : 'No data available, please enter the correct invoice number to query. It should be in the same month as the associated invoice (and the invoice amount should be negative)')}</th>
                                        </tr>
                                }
                                <tr style={{ border: 'none', height: '3rem' }}><th colSpan={15} style={{ border: 'none' }}></th></tr>



                                <tr><th colSpan={15} className='bill_title'>{langValue == 0 ? '关联的票据Related receipts(总金额total amount' : (langValue == 1 ? '关联的票据(总金额' : 'Related receipts (total amount)')}：<font style={{ color: 'red' }}>{cur.totalAmt}</font>)</th></tr>
                                <tr>
                                    <th style={{ width: '3rem' }}>{langValue == 0 ? '序号Serial number' : (langValue == 1 ? '序号' : 'Serial number')}</th>
                                    {relate_cols.filter(item => item.dataIndex != '作废原因').map(item => {
                                        return (
                                            <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                        )
                                    })}
                                </tr>
                                {
                                    detailList.map((d, i) => {
                                        return (
                                            <td>
                                                <td >{i + 1}</td>
                                                <td >{d ?.['票据号码']}</td>
                                                <td >{d ?.['开立日']}</td>
                                                <td>{d ?.['票据名称']}</td>
                                                <td>{d ?.['票据金额']}</td>
                                                <td>{langValue == 0 ? <>{d ?.['捐款项目']}<br />{d ?.en_proj}</> : (langValue == 1 ? d ?.['捐款项目'] : d ?.en_proj)}</td>
                                                <td>{d ?.['地区']}</td>
                                                <td>{d ?.['志工编号']}</td>
                                                <td>{d ?.['志工姓名']}</td>
                                                <td>{d ?.['手机号码']}</td>
                                                <td>{d ?.['邮箱']}</td>
                                            </td>
                                        )
                                    })
                                }

                            </tbody>
                        </table>
                        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
                            <Button
                                // className='submit_btn'
                                style={{ fontSize: '1.3rem', height: '2.6rem' }}
                                type='primary'
                                onClick={() => batchRelate(detailList)}
                            >
                                {langValue == 0 ? '关联Associated' : (langValue == 1 ? '关联' : 'Associated')}
                            </Button>
                        </div>
                    </> : <div>{langValue == 0 ? '请先选择红冲记录' : (langValue == 1 ? '请先选择红冲记录Please select the red flush record first' : 'Please select the red flush record first')}</div>}
            </Modal>
        </>
    )
}
